<main class="c-navigation" [ngClass]="{'c-navigation--multiple-option':hasMoreMenuButton}">
  <ng-container *ngIf="isShowCascadebar">
    <ng-container *ngFor="let cascadeMenu of cascadeMenus;let i = index">
      <maced-cascade-menubar [cascadeMenubarId]="'CascadeMenubar' + i" [cascadeMenubarLabel]="cascadeMenu.name"
        [cascadeMenuList]="cascadeMenu.menus" (menuEvent)="onClickCascadeMenu($event,i)" [hasMultipleOptionClass]="hasMultipleOptionClass"
        (backEvent)="onClickCascadeBack(i)" (closeEvent)="onClickCascadeClose()" [hasBackButton]="true"
        [hasTitleBar]="hasTitleBar(i)" [hasBreadcrumbs]="hasBreadcrumbs()" [cascadeLeftIconHidden]="true" *ngIf="cascadeMenu.isVisible">
        <ng-container ngProjectAs="[breadcrumbsPanel]">
          <maced-breadcrumbs [id]="breadcrumbsContainer" [linksData]="breadcrumbsName"
            [isLinksClickable]="isLinksClickable" [nextIconClass]="nextIconClass"
            [numberOfLinksVisible]="numberOfLinksVisible" [breadCrumbLimit]='breadCrumbLimit'>
          </maced-breadcrumbs>
        </ng-container>
      </maced-cascade-menubar>
    </ng-container>
  </ng-container>

  <maced-menubar id="Menubar" [menuList]="menuList" [isShowExpandCollapse]="true" [isMenubarExpand]="true" [hasMultipleOptionClass]="hasMultipleOptionClass"
    *ngIf="isShowMenubar" (closeMenubarEvent)="onCloseMenubar()" (menuEvent)="onClickMenu($event)" [hasMoreMenuButton]="hasMoreMenuButton"
    (moreMenuEvent)="onClickMoreMenu()" [hasTitleBar]="true" [menuLeftIconHidden]="true">
  </maced-menubar>

  <maced-toolbar toolbarId="ToolbarId" [ariaExpanded]="isShowMenubar" [hamburgerAriaLabel]="toolbarHamburgerAriaLabel" hamburgerTooltip="Menu"
    [toolbarMenuList]="toolbarMenuList" expandTooltip="Expand" [isHamburgerActive]="isShowMenubar || isShowCascadebar"
    (hamburgerEvent)="onClickHamburger()" (menuEvent)="onClickToolMenu($event)" *ngIf="isShowToolbar">
  </maced-toolbar>
  <h1>Navigation</h1>
</main>